import { api } from './api';

/**
 * 把司机手机上的故障报到后端日志(Railway 日志里搜 `[ClientError]`)。
 *
 * ★ 为什么要有:司机手机上的报错我们看不到。iOS 17.7 的 iPhone 11 地图打不开,
 *   同型号的另一台却能开 —— 只靠截图,那行小字总是截不到,原因只能猜。
 *
 * ★ 只报错误信息和设备版本,**不报**订单、收件人、坐标。
 * ★ 发不出去就算了:上报本身绝不能再弄出一个错误给司机看。
 * ★ 同一种故障一次打开只报一次 —— 「重新加载地图」点十下不该刷十条。
 */
const sent = new Set<string>();

export function reportClientError(input: {
  kind: string;
  reason?: string;
  message?: string;
  details?: string[];
}): void {
  const key = `${input.kind}:${input.reason ?? ''}`;
  if (sent.has(key)) return;
  sent.add(key);
  void api('/driver/client-errors', {
    method: 'POST',
    body: {
      ...input,
      message: input.message?.slice(0, 2000),
      details: input.details?.slice(-10).map((d) => d.slice(0, 500)),
      userAgent: navigator.userAgent.slice(0, 400),
    },
  }).catch(() => undefined);
}

/** 错误对象 → 一行字(带名字,iOS 上很多报错只有名字有用) */
export function errorText(e: unknown): string {
  if (e instanceof Error) return `${e.name}: ${e.message}`;
  if (e && typeof e === 'object' && 'name' in e) return `${String((e as { name: unknown }).name)}: ${String((e as { message?: unknown }).message ?? '')}`;
  return String(e);
}
